var current = {
    compile: function(template) {
        return template;
    }
};

var TemplateService = function TemplateService () {};

TemplateService.register = function register (userImplementation) {
    current = userImplementation;
};

TemplateService.compile = function compile (template) {
    return current.compile(template);
};

export default TemplateService;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-charts/dist/es/services/template-service.js
// module id = 2358
// module chunks = 29